import React, { Component } from 'react'
import { observer } from 'mobx-react'

import PresentationsBuilding from './PresentationsBuilding'
import PowerpointBuilder from './PowerpointBuilder'
import PresentationsStore from './PresentationsStore'

import './presentations.scss'

@observer
class Presentation extends Component {
    constructor(props) {
        super(props)
        this.presentationsStore = new PresentationsStore(props.store)
        this.kickoffLoad()
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeydown)
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeydown)
        this.presentationsStore.flushPendingSave()
    }

    kickoffLoad = () => {
        this.presentationsStore.clearBuildingError()
        const surveysReady = this.presentationsStore.getAllSurveys()
        const { match, location } = this.props
        const id = match?.params?.id

        const query = new URLSearchParams(location?.search || '')
        const isNew = location?.state?.isNew || query.get('isNew') === 'true'

        const event = location?.state?.event ?? query.get('event') ?? undefined
        const entrySurvey = location?.state?.entrySurvey ?? query.get('entrySurvey') ?? undefined
        const startingSurveyId = location?.state?.startingSurveyId
            ?? query.get('startingSurveyId')
            ?? undefined
        const entryTitle = location?.state?.entryTitle ?? query.get('entryTitle') ?? undefined

        const presentationReady = id
            ? this.presentationsStore.fetchPresentationById(id)
            : Promise.resolve(null)

        Promise.all([surveysReady, presentationReady])
            .then(([, presentation]) => {
                if (!presentation) {
                    if (isNew && id) {
                        this.presentationsStore.startNewPresentation(
                            id,
                            event,
                            entrySurvey,
                            entryTitle,
                            startingSurveyId,
                        )
                        return
                    }
                    this.presentationsStore.setBuildingError(
                        'We couldn\'t find this presentation.',
                    )
                    return
                }
                try {
                    const data = typeof presentation.data === 'string'
                        ? JSON.parse(presentation.data)
                        : presentation.data
                    this.presentationsStore.openPresentation({ ...presentation, data })
                } catch (e) {
                    console.error('Failed to parse presentation data', e)
                    this.presentationsStore.setBuildingError(
                        'This presentation\'s saved data is corrupted and can\'t be opened.',
                    )
                }
            })
            .catch((e) => {
                console.error('Failed to load presentation', e)
                this.presentationsStore.setBuildingError(
                    e?.message || 'We couldn\'t load this presentation.',
                )
            })
    }

    handleRetry = () => {
        this.kickoffLoad()
    }

    handleBack = () => {
        const { history } = this.props
        if (history) history.push('/presentations')
    }

    handleKeydown = (e) => {
        if (this.presentationsStore.stage !== 'builder') return

        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault()
        }

        switch (e.key) {
            case 'ArrowUp':
                this.presentationsStore.handleKeyboardListener(-1)
                break
            case 'ArrowDown':
                this.presentationsStore.handleKeyboardListener(1)
                break
            default:
                break
        }
    }

    render() {
        const store = this.presentationsStore

        if (store.stage === 'builder') {
            return <PowerpointBuilder store={store} />
        }

        return (
            <PresentationsBuilding
                store={store}
                onRetry={this.handleRetry}
                onBack={this.handleBack}
            />
        )
    }
}

export default Presentation
